

























































import { Component, Vue, Watch, Prop, Provide } from "vue-property-decorator";
import commonBox from "./components/commonBg.vue";
import firstBg from "./components/firstBg.vue";
import shareBg from "./components/shareBg.vue";
import { AnnualAccount } from "./middleware/AnnualAccount";
import loginDialog from "@/components/dialog/login/index";
import { nodataPage, dataPage, nodataposter, dataposter } from "./data";
let _this: any = null;
let start: number = -1;
@Component({
  components: {
    commonBox,
    firstBg,
    shareBg,
  },
  watch: {
    startNum(newVal, oldVal) {
      this.$nextTick(() => {
        let pageList = this.$refs["page" + newVal] as any;
        if (!pageList) return;
        let page = pageList[0];
        let animateFluid = page.querySelector(".animate-fluid");
        _this.disabled = false;
        let animateBox = animateFluid.querySelector(".animatebox");
        let animateBoxParent = animateFluid.querySelector('.animatebox-parent');
        if (
          animateFluid.className.indexOf("canAnimate") != -1 &&
          animateBox.className.indexOf("animated") == -1
        ) {
          let rect = animateBox.getBoundingClientRect();
          let pList = animateBox.querySelectorAll("p");
          animateBox.className = "animatebox animated";
          animateBoxParent.style.height = rect.height + "px";
          animateFluid.style.visibility = "visible";
          animateBox.style["animation-duration"] = (pList.length / 3) * 2 + "s";
          clearTimeout(_this.timer);
          _this.timer = null;
          _this.disabled = true;
          _this.timer = setTimeout(() => {
            _this.disabled = false;
          }, (pList.length / 3) * 2 * 1000);
        }
        // _this.opts.start = 3;
      });
    },
  },
})
export default class extends AnnualAccount {
  public unLogin: boolean = false;
  public start: boolean = true;
  public nickName: string = "";
  public disabled: boolean = false;
  public timer: any = null;
  public data: any = {};
  public pageList: string[] = [
    "startPage",
    "page1",
    "page2",
    "page3",
    "page4",
    "page5",
    "page6",
    "page-share",
  ];
  public posterIndex: number = 0;
  public nodataPage: any = nodataPage;
  public dataPage: any = dataPage;
  public list: any = [];
  public posterArr: any = [];
  public posterItem: any = "";
  public postList: any = {
    0: [
      "2020年，",
      "全民抗战创造历史新篇，",
      "英雄的星火在时光长河中传承,",
      "继续砥砺前行|#旗敬真我#。",
    ],
    1: [""],
  };
  public startNum: number = -1;
  public hasData:boolean = false;
  public nodataBgList = [
    "https://picbed.qunarzz.com/702dcb33dc92497a71c6612152fed304.png",
    "https://picbed.qunarzz.com/ae75f86b25cd31f9210cb56fb3793549.png",
    "https://picbed.qunarzz.com/143c3595ba658aef586c818bb04f6fbd.jpg",
    "https://picbed.qunarzz.com/c5c4c6ef0aaf1dab571d7ee9d49bc0f5.png",
    "https://picbed.qunarzz.com/3b766ec938e445e7a916df6f3b476077.jpg",
    "https://picbed.qunarzz.com/0025bf312065f6facd35895b050dc0ab.jpg",
  ];
  public hasDatabgList = [
    "https://picbed.qunarzz.com/702dcb33dc92497a71c6612152fed304.png",
    "https://picbed.qunarzz.com/ae75f86b25cd31f9210cb56fb3793549.png",
    "https://picbed.qunarzz.com/ae75f86b25cd31f9210cb56fb3793549.png",
    "https://picbed.qunarzz.com/143c3595ba658aef586c818bb04f6fbd.jpg",
    "https://picbed.qunarzz.com/c5c4c6ef0aaf1dab571d7ee9d49bc0f5.png",
    "https://picbed.qunarzz.com/3b766ec938e445e7a916df6f3b476077.jpg",
    "https://picbed.qunarzz.com/0025bf312065f6facd35895b050dc0ab.jpg",
  ];
  public bgList: string[] = [];
  public opts = {
    start: 0,
    dir: "v",
    duration: 500,
    beforeChange: (prev: number, next: number) => {
      if (_this.unLogin || _this.disabled) {
        // this.popupVisible = true;
        if (_this.disabled) {
          return false;
        }
        loginDialog({
          callback: () => {
            _this.unLogin = false;
            _this.userInfo();
          },
        });
        return false;
      }
    },
    afterChange: (prev: number, next: number) => {
      if (window._hmt) {
        if (prev < next) {
          window._hmt.push(["_trackPageview", "/#" + this.pageList[next]]);
        }
      }
      _this.startNum = next;
    },
  };
  public initAnnualAccount() {
    if (this.unLogin) {
      loginDialog({
        callback: () => {
          this.userInfo(()=>{
              this.unLogin = false;
              this.start = false;
              this.startNum = 0;
          });
        },
      });
    } else {
      this.start = false;
      this.startNum = 0;
    }
  }
  public queryDays(_endDate: any) {
    _endDate = _endDate.replace(/\-/gi, "/") + " 00:00:00";
    let endDate = new Date(_endDate).getTime();
    let startDate = new Date("2020/01/01 00:00:00").getTime();
    return (endDate - startDate) / 1000 / 60 / 60 / 24;
  }

  public initTravelInfo(data: any) {
    if (data) {
      this.data = data;
      let firstOrderDepartureTime = this.data.firstOrderDepartureTime;
      this.data.days = this.queryDays(this.data.firstOrderDepartureTime);
      let dataPage = [...this.dataPage] as any;
      let dataPageStr = dataPage.join("&&&");
      let month = firstOrderDepartureTime.split("-")[1];
      let day = firstOrderDepartureTime.split("-")[2];
      this.hasData = true;
      this.list = dataPageStr
        .replace("$days", this.data.days)
        .replace("$month", month)
        .replace("$day", day)
        .replace("$orderNums", this.data.orderNums)
        .replace("$totalDistance", this.data.totalDistance)
        .replace("$maxHours", this.data.maxHours)
        .replace("$gongli", this.data.maxDistance)
        .replace("$arrivalCityList", this.data.arrivalCityList.split("##")[0])
        .split("&&&");
      if (
        this.data.firstOrderTongChengRen &&
        this.data.firstOrderTongChengRen != "NULL"
      ) {
        this.list = this.list
          .join("&&&")
          .replace(
            "$contentslot",
            `
                <p>你与<span class="strong">${this.data.firstOrderTongChengRen}</span>同行，前往目的地<span class="strong">${this.data.firstOrderArrivalCity}</span>，</p>
                <p>TA与你共同见证万物重启</p>
              `
          )
          .split("&&&");
      } else {
        this.list = this.list
          .join("&&&")
          .replace(
            "$contentslot",
            `
                <p>前往目的地<span class="strong">${this.data.firstOrderArrivalCity}</span>，</p>
                <p>冰雪消融又见春 那一定是2020最美好的记忆</p>
              `
          )
          .split("&&&");
      }
      this.posterArr = dataposter;
      this.bgList = this.hasDatabgList;
    } else {
      this.hasData = false;
      this.list = this.nodataPage;
      this.posterArr = nodataposter;
      this.bgList = this.nodataBgList;
    }
    this.posterItem = this.posterArr[
      Math.floor(Math.random() * this.posterArr.length)
    ];
  }

  public userInfo(callback?:any) {
    this.getUserInfo().then((res: any) => {
      if (res.code >= 400 && res.code <= 500) {
        this.unLogin = true;
      } else {
        this.unLogin = false;
        this.nickName = res.data;
        this.travelInfo().then((data: any) => {
          this.initTravelInfo(data);
          callback&&callback();
        });
      }
    });
  }
  public created() {
    _this = this;
    if(hysdk.sniff.scheme){
      this.$nextTick(()=>{
        (document as any).getElementById('annualAccount').className = 'hybird'
      })
    }
    this.userInfo();
  }
}
